<template>
<div>
  <Loading :loading="this.loading"></Loading>
  <div v-show="!loading" class="content-wrapper">
    <div class="container">
      <article>
        <section class="section white-panel mb8 pt28">
          <h2 class="text-center mb16">おすすめ新車リース</h2>
          <!-- Slider main container -->
          <div class="swiper swiper-container" v-if="leaseDataGetFlag">
              <!-- Additional required wrapper -->
              <div class="swiper-wrapper">
                  <!-- Slides -->
                  <div class="swiper-slide" v-for="(value, order) in this.carLease" :key="order">
                    <img :src="value.img_file" class="mb12" alt="">
                    <h2 class="text-center fs14">{{ value.maker_nm }} {{ value.syasyu_nm }}</h2>
                    <h2 class="text-center"><span class="fs13 font-weight-normal">月額</span> <span class="fs20">{{ $filters.addComma(Number(value.cost_total)) }}</span> <span class="fs13 font-weight-normal">円〜×{{ value.terms }}回</span></h2>
                    <button class="button fs16 mt8 mb12 pd16 radius200 w80p" v-on:click="jsOpenBrowser(value.estimateCarURL + '&popinfo=ID_' + nativeData.popinfoid, 'EstimateButton')">この車の見積もりを見る</button>
                  </div>
              </div>
              <!-- If we need pagination -->
              <div class="swiper-pagination"></div>

              <!-- If we need navigation buttons -->
              <div v-on:click="nativeEVENTSet('LeaseButton', 'CHANGE_LEASE_CAR', 'TAP')" class="swiper-button-prev"></div>
              <div v-on:click="nativeEVENTSet('LeaseButton', 'CHANGE_LEASE_CAR', 'TAP')" class="swiper-button-next"></div>
          </div>
          <div v-else>
            <p class="mb16 text-center">
              <a><img src="/lib/images/lease-promotion.png" alt=""></a>
            </p>
          </div>
        </section>
        <section class="section white-panel pt20 mb8">
          <h2 class="text-center">ぴったりの車を探そう</h2>
          <button class="button fs16 mt8 mb12 pd16 radius200 w80p" v-on:click="jsOpenBrowser( leaseUrl + '?c=001&popinfo=ID_' + nativeData.popinfoid, 'TrialEstimateButton')">お試し見積もり</button>
        </section>
        <section class="section white-panel pt20 mb8">
          <h2 class="text-center mb8">リースのご紹介</h2>
          <p class="mb16 text-center fs14">
            頭金なしで新車に乗れる！<br>メンテナンスまで丸ごとお任せ
          </p>
          <button class="button button-gray w80p pd12 ic-left ic-car-lease2 radius200 fs14" v-on:click="jsOpenBrowser( leaseUrl + '?c=003&popinfo=ID_' + nativeData.popinfoid, 'FirstButton')">もっと詳しく見る</button>
        </section>
        <section class="section white-panel pt24 pb24" v-if="ssInfo.trade_in_flag === 1">
          <h2 class="text-center">お近くのSSで下取りまでお任せ</h2>
        </section>
      </article>

      <!-- カーケアTOPに戻るボタン -->
      <form name="fm">
        <input id="tsid" type="hidden" name="tsid" v-bind:value="nativeData.tsid">
        <input id="popinfoid" type="hidden" name="popinfoid" v-bind:value="nativeData.popinfoid">
        <input id="otoken" type="hidden" name="otoken" v-bind:value="nativeData.otoken">
        <input id="x_cls_app_version" type="hidden" name="appversion" v-bind:value="versionData.appVersion">
        <input id="x_cls_os" type="hidden" name="platform" v-bind:value="versionData.platform">
        <input id="x_cls_os_version" type="hidden" name="osversion" v-bind:value="versionData.osVersion">
      </form>
    </div>

  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import car from '@/store/Api/car'
import profileApi from '@/store/Api/Common/profile'
import ssApi from '@/store/Api/Common/ss'
import carLeaseApi from '@/store/Api/Common/carLease'
import modal from '@/assets/v2/modal'
import Loading from '@/views/v2/Loading.vue'
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export default {
  props: [
    'tsid',
    'otoken',
    'popinfoid',
    'x_cls_app_version',
    'x_cls_os',
    'x_cls_os_version',
    'oilExchanged',
    'mileage'
  ],
  data () {
    return {
      loading: true,
      profileInfo: [],
      ssInfo: [],
      carLease: [],
      mySwiper: '',
      carLeaseParam: {
        tsid: '',
        otoken: '',
        katasi: null,
        ruibtu: null,
        model_code: null
      },
      leaseDataGetFlag: true,
      leaseUrl: process.env.VUE_APP_LEASE_URL
    }
  },
  methods: {
    ...mapActions('CAR', [
      'setCar'
    ]),
    setProfileInfo (profileInfo) {
      this.profileInfo = profileInfo
    },
    setSsInfo (ssInfo) {
      this.ssInfo = ssInfo
    },
    setCarLeaseInfo (carLease) {
      this.carLease = carLease
    },
    openErrorModal (message) {
      modal.alert(message)
    },
    jsOpenBrowser: function (url, type) {
      // この車の見積を見るボタン
      if (type === 'EstimateButton') {
        this.nativeEVENTSet('EstimateButton', 'OPEN_LEASE_SITE', 'TAP')
      }
      // お試し見積もりボタン
      if (type === 'TrialEstimateButton') {
        this.nativeEVENTSet('TrialEstimateButton', 'OPEN_LEASE_SITE', 'TAP')
      }
      // 初めての方へボタン
      if (type === 'FirstButton') {
        this.nativeEVENTSet('FirstButton', 'OPEN_LEASE_SITE', 'TAP')
      }
      // 車の選び方
      if (type === 'CarSelectButton') {
        this.nativeEVENTSet('CarSelectButton', 'OPEN_LEASE_SITE', 'TAP')
      }
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.openBrowser(url)
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.openBrowser.postMessage(url)
      }
    }
  },
  computed: {
    ...mapGetters('CAR', [
      'car'
    ]),
    nativeData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.tsid = this.tsid
      getData.popinfoid = this.popinfoid
      getData.otoken = this.otoken
      return getData
    },
    versionData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.appVersion = this.x_cls_app_version
      getData.platform = this.x_cls_os
      getData.osVersion = this.x_cls_os_version
      return getData
    }
  },
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(true)
    let isApiError = false

    // バージョン情報が一つでも未定義の場合はエラーダイアログを表示.
    if (this.isCLSAppVersionError(this.x_cls_app_version, this.x_cls_os, this.x_cls_os_version)) {
      this.openErrorModal('アプリバージョンの認証でエラーが発生しました。')
      isApiError = true
      return
    } else {
      this.versionData.appVersion = this.versionData.appVersion ? this.versionData.appVersion : '0.0.0'
      this.versionData.platform = this.versionData.platform ? this.versionData.platform : 'iRidge'
      this.versionData.osVersion = this.versionData.osVersion ? this.versionData.osVersion : '0.0'
    }

    // profile情報マスタ取得。
    await profileApi.get(this.nativeData.tsid, this.nativeData.otoken, this.appVersionMakeRequestHeder(this.versionData)).then(res => {
      this.setProfileInfo(res.data.body)
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })
    // SS情報マスタ取得
    await ssApi.get(this.profileInfo.best_myss.code).then(res => {
      this.setSsInfo(res.data.body.ss_info)
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })
    // 車検証データ取得
    await car.get(this.nativeData.tsid).then(res => {
      if (res.data.car.length > 0) {
        this.setCar(res.data.car[0])
        // エンジンオイルの交換の可否をセット(デフォルトでtrue)
        this.car.oil_exchanged = true
        // 見積り掲示画面からのアクセスの場合、エンジンオイルの交換可否、走行距離をセットする
        if (!(this.oilExchanged === undefined)) {
          this.car.oil_exchanged = this.oilExchanged
        }
        if (this.mileage) {
          this.car.mileage = this.mileage
        }
        // // 車検証データをレコメンド情報取得パラメータに整形する
        this.carLeaseParam.model_code = this.car.model_code
        this.carLeaseParam.katasi = this.car.type_designation_number
        this.carLeaseParam.ruibtu = this.car.classification_division_number
      }
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })
    // 車検証データをレコメンド情報取得パラメータに整形する
    // console.log(this.nativeData)
    // console.log(this.carLeaseParam.tsid)
    this.carLeaseParam.tsid = this.nativeData.tsid
    this.carLeaseParam.otoken = this.nativeData.otoken
    // this.carLeaseParam.model_code = 2
    // this.carLeaseParam.katasi = '06924'
    // this.carLeaseParam.ruibtu = '0002'
    // レコメンド情報取得
    await carLeaseApi.post(this.carLeaseParam, this.appVersionMakeRequestHeder(this.versionData)).then(res => {
      if (res.data.sum === 0) {
        this.leaseDataGetFlag = false
      } else {
        this.setCarLeaseInfo(res.data.body.recommend_cars)
      }
    }).catch(e => {
      this.leaseDataGetFlag = false
    })
    if (!isApiError) {
      this.loading = false
    }
    // [eventTrack] リースTOP画面表示完了
    this.nativePVset('LEASETOP')

    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper('.swiper-container', {
      modules: [Navigation, Pagination],
      // Optional parameters
      loop: false,
      // If we need pagination
      pagination: {
        el: '.swiper-pagination'
      },
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar'
      }
    })
  },
  components: {
    Loading
  }
}
</script>
